<template>
<v-navigation-drawer permanent class="onboarding navDrawer" width="250">
  <div class="navContainer">
    <div class="logo-box">
      <div class="backUrl" v-if="!!backLinkText && !!backLinkUrl" @click="$router.push(backLinkUrl)">
        <img class="icon" src="@/assets/path-2-copy.png" />
        <span class="text-purple"> {{backLinkText}}</span>
      </div>
      <div class="nav-title" v-if="title">
        <span><img :src="logoUrl" alt=""></span>
      </div>
      <div><span v-if="title" class="logo-title">{{ title }}</span></div>
    </div>
    <section v-for="(s,i) of items" :key="i">
        <div class="navItem" v-bind:class="[s.status]">
          <div class="statusIcon"></div>
          <router-link class="label" :to="s.path">
            <label>{{s.label}}</label>
          </router-link>
        </div>
        <div v-if="i < (items.length-1)" class="dashed-line" :class="[s.status]"></div>
    </section>
  </div>
</v-navigation-drawer>
</template>

<script>
export default {
  name: "runprNavDrawer",
  props: ['items', 'title', 'backLinkText', 'backIcon', 'backLinkUrl', 'logoUrl'],
  data() {
    return {};
  },
  methods: {
    updateView(view) {
      this.$emit("updateView", view);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.router-link-exact-active,.router-link-active {
    &.label {
        color: #000000;
        font-weight: bold;
    }
}
%circle {
    background-color: white !important;
    border: 1px solid #303030;
    height: 12px;
    width: 12px;
    min-width: 0;
    border-radius: 50%;
}

%circle-filled {
    background-color: #5d409f !important;
    border: 1px solid #303030;
    height: 12px;
    width: 12px;
    min-width: 0;
    border-radius: 50%;
}

.dashed-line {
    height: 25px;
    border-left: 1px dashed #b0b0b0;
    margin-left: 5px;
    margin-top: 2px;
    margin-bottom: 2px;
}

.nav-title {
    font-weight: 500;
    font-size: 16px;
    overflow-wrap: break-word;
    img{
        width: 70px;
        height: 70px;
        object-fit: contain;
        border-radius: 50%;
    }
}

.onboarding {
    font-family: Montserrat;
    position: relative;

    .navContainer {
        width: 242px;
        position: relative;
        display: block;
        padding-left: 32px;
        padding-top: 32px;
        padding-right: 10px;
        font-size: 14px;

        .backUrl {
            display: flex;
            padding-bottom: 16px;
            cursor: pointer;
            user-select: none;

            .icon {
                height: 12px;
                margin-top: 3px;
                padding-right: 12px;
            }

            .text-purple {
                color: $color-primary;
                font-weight: bold;
            }
        }

        section {
            // padding-bottom: 16px;
            // margin-bottom: 26px;

            // header {
            //     font-size: 12px;
            //     padding-bottom: 10px;
            // }

            .dashed-line {
                height: 25px;
                border-left: 1px dashed #b0b0b0;
                margin-left: 5px;
                &.complete {
                    border-color: #5d409f;
                }
            }

            .navItem {
                display: flex;
                align-items: center;

                .statusIcon {
                    margin-right: 10px;
                }

                .label {
                    text-decoration: none;
                    color: black;
                    font-size: 14px !important;
                }

                &.pending {
                    .statusIcon {
                        @extend %circle;
                    }
                }

                &.active {
                    a.label {
                        color: #000000;
                        font-weight: bold;
                    }

                    .statusIcon {
                        @extend %circle;
                    }
                }

                &.complete {
                    a.label {
                        color: #5d409f;
                    }

                    .statusIcon {
                        @extend %circle-filled;
                    }
                }
            }
        }
    }
    // .navItem {}
}
.navDrawer {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.1);
    background-color: #f9f9f9;
    width: 242px;
    float: left;
    height: calc(100vh - 66px);
    position: fixed;
    padding-bottom: 66px;
    overflow: auto;
    top: 65px;
    z-index: 0;
}

.logo-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 22px;

    >:nth-child(n) {
      margin-bottom: 16px;
    }
    >:last-child {
      margin-bottom: 32px;
    }
    .logo-title {
       font-weight: 600;
       font-size: 14px;
       color: #444444;
       font-family: Montserrat;
    }
}

</style>
